import React from 'react'
import RolesTable from './components/RolesTable'


export default function RoleManagement() {
 
  return (
    <RolesTable />
  )
}